import {Injectable} from '@angular/core';
import {ModalService} from '../modal-service.service';
import {LodgementSuccessModalComponent} from './lodgement-success-modal.component';

@Injectable({
    providedIn: 'root'
})
export class LodgementSuccessModalService extends ModalService {
    showModal() {
        this.createModalComponent(LodgementSuccessModalComponent);
        const modalComponent = this.modalComponentRef.instance as LodgementSuccessModalComponent;
        this.showModalComponent();
        return modalComponent.modalClosed;
    }
}
